
import { useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon, useMediaQuery,useTheme} from '@mui/material';
import { AutoCompleteCliente, AutoCompleteFabrica, IVFormErrors, VForm, VSwitch, VTextField, VTextFieldData, VTextFieldNumber, VTextFieldNumberReal, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { CreditoService } from '../../../shared/services/api/cadastros/CreditoService';



interface IFormData {
  idcli:string,
  idfabrica:string,
  emissao: Date,
  historico:string,
  valor: number,
}

export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  idcli: yup.string().required(),
  idfabrica: yup.string().required(),
  emissao: yup.date().required(),
  historico: yup.string().required(),
  valor: yup.number().required(),
});

export const DialogoCreditos: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const {formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down('sm'));

  const handleSave = (dados: IFormData) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);

        if (props.id === 'novo') {
          CreditoService
            .create(dadosValidados)
            .then((result) => {
              setIsLoading(false);

              if (result instanceof Error) {
                alert(result.message);
              }else {
                onClose(valueProp);
              }
            });
        } else {
          CreditoService
            .updateById(props.id, dadosValidados)
            .then((result) => {
              setIsLoading(false);
              if (result instanceof Error) {
                alert(result.message);
              } else {
                onClose(valueProp);
              }
            });
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};

        errors.inner.forEach(error => {
          if (!error.path) return;

          validationErrors[error.path] = error.message;
        });

        formRef.current?.setErrors(validationErrors);
      });
  };

  useEffect(() => {
    if(props.id !== 'novo'){
      if(open == true){
        setIsLoading(true);
        CreditoService.getById(props.id)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              alert(result.message);
            } else {
              formRef.current?.setData(result);
            }
          });
      }
    }else{
      formRef.current?.setData({
        idcli: '',
        idfabrica: '',
        emissao: '',
        valor: 0,
      });
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleDelete = () => {
    if (confirm('Realmente deseja apagar?')) {
      CreditoService.deleteById(props.id)
        .then(result => {
          if (result instanceof Error) {
            alert(result.message);
          } else {
            alert('Registro apagado com sucesso!');
            onClose(valueProp);
          }
        });
    }
  };

  return (
    <Dialog
    open={open}
    fullWidth // Garante que o diálogo ocupe toda a largura permitida
    maxWidth="md" // Define a largura máxima como extra large (ou pode usar 'lg', 'md', etc.)
    sx={{ '& .MuiDialog-paper': { maxHeight: '70vh' } }} // Define altura máxima para 90% da viewport
    {...other}
  >
      <DialogTitle>Crédito</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef}  onSubmit={handleSave}  placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
          <Grid container direction="column" padding={1} >
            <Grid container item direction="row" padding={1} spacing={1}>           
                <Grid container item direction="row" spacing={1} > 
                  <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>          
                    <AutoCompleteCliente
                    />
                  </Grid>               
                    <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <VTextFieldData
                      fullWidth
                      size='small'
                      name='emissao'
                      label='Emissão'
                      disabled={false}
                    />
                  </Grid>               
                </Grid>
                <Grid container item direction="row" spacing={1} >
                               
                  <Grid item xs={12} sm={9} md={9} lg={9} xl={9}>          
                  <AutoCompleteFabrica
                     isExternalLoading={isLoading}
                    />
                  </Grid>                 
                  <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                    <VTextFieldNumberReal
                      fullWidth
                      size='small'
                      name='valor'
                      disabled={isLoading}
                      label='Valor'
                    />
                  </Grid>                         
                </Grid>
                <Grid container item direction="row" spacing={1} >                
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <VTextField
                      fullWidth
                      size='small'
                      name='historico'
                      disabled={isLoading}
                      label='Historico'
                    />
                  </Grid>                         
                </Grid>
            </Grid>
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
  <Grid
    container
    spacing={2}
    direction={smDown ? 'column' : 'row'}
    justifyContent="center"
    alignItems="stretch"
    sx={{ width: '100%', px: 2, pb: 1 }}
  >
    <Grid item xs={12} sm={'auto'}>
      <Button
        fullWidth
        color="error"
        startIcon={<Icon>delete</Icon>}
        variant="contained"
        onClick={handleDelete}
      >
        Excluir
      </Button>
    </Grid>
    <Grid item xs={12} sm={'auto'}>
      <Button
        fullWidth
        variant="outlined"
        color="error"
        onClick={handleCancel}
      >
        Cancelar
      </Button>
    </Grid>
    <Grid item xs={12} sm={'auto'}>
      <Button
        fullWidth
        variant="outlined"
        autoFocus
        onClick={save}
      >
        Confirmar
      </Button>
    </Grid>
  </Grid>
</DialogActions>
    </Dialog>
    
  );
}; 